import { shadows, theme } from '@/utils/theme';

export const classes = {
  wrapper: 'p-2 bg-white rounded-xl dark:bg-transparent',
  input: 'mention-input text-base text-grey-8 dark:text-mauve-1',
  suggestionsList: 'min-h-0 max-h-[200px] max-w-[300px] overflow-y-auto',
  suggestion:
    'transition-colors duration-100 text-grey-8 font-normal py-2 px-4 mb-2 rounded-lg bg-white hover:bg-grey-2 dark:text-mauve-1 dark:bg-transparent dark:hover:bg-white/[0.07]',
};

export const styles = {
  wrapper: {
    '& .mention-input': {
      width: '100%',
      fontSize: '0.875rem', // text-sm
    },
    '& .mention-input__input': {
      outline: 'none',
    },
    '& strong': {
      backgroundColor: theme.palette['grey-3'].main,
      padding: '0.25rem 0', // py-1
      borderRadius: '0.5rem', // rounded-lg
    },
    '.dark & strong': {
      backgroundColor: 'rgba(255,255,255,0.1)',
      color: theme.palette['mauve-1'].main,
    },
  },
  suggestionsWrapper: {
    position: 'absolute',
    top: 'unset',
    left: 'unset',
    '& .mention-input__suggestions': {
      position: 'relative !important',
      left: '0 !important',
      top: '0 !important',
      borderRadius: '1rem', // rounded-2xl
      padding: '0.5rem', // p-2
      boxShadow: shadows.dialog,
    },
    // eslint-disable-next-line witmetrics/no-multiline-comments
    /* the react-mentions dropdown container sets its bg inline (white); override
      with !important so it reads as a clean dark panel (items are transparent)
     */
    '.dark & .mention-input__suggestions': {
      backgroundColor: '#332e43 !important',
      border: '1px solid rgba(255,255,255,0.1)',
    },
  },
};
